export const ChangeTitle = (newTitle) =>{
    document.title=newTitle;
}